export default [
  [
    {
      id: 'companyType',
      type: 9,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'บริษัท *' } },
    },
  ], [
    {
      id: 'firstname',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ชื่อ - นามสกุล *' } },
    }, {
      id: 'nationalId',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'หมายเลขบัตรประชาชน' } },
    }, {
      id: 'birthDay',
      type: 8,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันเกิด' } },
    }, {
      id: 'email',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'Email' } },
    }, {
      id: 'phoneNumber',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เบอร์โทรศัพท์ *' } },
    },
  ], [
    {
      id: 'department',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'แผนก *' } },
    }, {
      id: 'startDate',
      type: 8,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่เริ่ม' } },
    }, {
      id: 'quitDate',
      type: 8,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'วันที่ออก' } },
    }, {
      id: 'salary',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'เงินเดือน' } },
    }, {
      id: 'insuranceNumber',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ประกัน' } },
    },
  ], [
    {
      id: 'bankName',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'ชื่อธนาคาร' } },
    }, {
      id: 'bankAccountNumber',
      type: 0,
      span: 8,
      offset: 0,
      props: { padding: '8px 0', width: '100%', title: { text: 'หมายเลขบัญชีธนาคาร' } },
    },
  ], [
    {
      id: 'skills',
      label: 'ความสามารถ *',
      span: 24,
      type: 5,
    },
  ],
  // [
  //   {
  //     id: 'images',
  //     span: 24,
  //     type: 7,
  //     props: { margin: '8px 0' },
  //   },
  // ],
]
